import React, { useEffect, useState } from "react";
import ProductLandingHeader from "../CommonProductsPages/ProductLandingHeader";
import { getProductDetails } from "../CommonProductsPages/ProductRepo";
import savetime from "../../images/airesearch_feautures/savetime.png";
import accuracy from "../../images/airesearch_feautures/accuracy.png";
import dataSecurity from "../../images/airesearch_feautures/data_security.png";
import multiPlatoform from "../../images/airesearch_feautures/multi_platoforms.png";
import userFriendly from "../../images/airesearch_feautures/user_friendly.png";
import androidApkLogo from "../../images/download_logos/android-apk-white.png";
import playStoreLogo from "../../images/download_logos/playstore-white.png";
import appStoreLogo from "../../images/download_logos/appstore-white.png";
import webLogo from "../../images/download_logos/webpage-white.png";
import ProductLoadingPage from "../CommonProductsPages/ProductLoadingPage";
import ProductHeader from "../CommonProductsPages/ProductHeader";
import SummaryPage from "../CommonProductsPages/SummaryPage";
import PrivacyPolicy from "../CommonProductsPages/PrivacyPolicy";
import Footer from "../../HomePage/Footer";
import UnavailableAlert from "../CommonProductsPages/UnavailableAlert";

function AiclinicsMainPage() {
  const [productLoading, setProductLoading] = useState(false);
  const [product, setProductData] = useState({});
  const [navOpen, setNavOpen] = useState(false);

  const toggleNav = () => {
    setNavOpen(!navOpen);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setNavOpen(false);
      }
    };
    console.log(window.innerWidth);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const sections = [
    {
      id: "#productHome",
      sectionName: "Home",
    },
    {
      id: "#features",
      sectionName: "Features",
    },
    {
      id: "#management",
      sectionName: "Management",
    },
    {
      id: "#architecture",
      sectionName: "Architecture",
    },
    {
      id: "#whyUs",
      sectionName: "Why Us",
    },
    {
      id: "#download",
      sectionName: "Download",
    },
    {
      id: "#privacy",
      sectionName: "Privacy Policy",
    },
  ];

  const getProduct = () => {
    getProductDetails({
      productId: 1,
      setProductLoading,
      setProduct: setProductData,
    });
  };

  useEffect(() => {
    getProduct();
  }, []);

  if (productLoading) {
    return <ProductLoadingPage />;
  }

  return (
    <div
      className="product-description-div"
      style={{
        "--background-image": `url(${product.imageUrl})`,
      }}
    >
      <ProductHeader
        toggleNav={toggleNav}
        navOpen={navOpen}
        sections={sections}
      />
      <ProductLandingHeader product={product} />

      <SummaryPage
        summary="AiClinics is a comprehensive clinic and camp management tool, as well as a unified healthcare operations and research platform. It is designed to support integrated clinical workflows, pharmacy management, and laboratory coordination.
            Built for doctors, clinical researchers, and administrative teams, AiClinics enables controlled, compliant, and traceable healthcare data management across departments, making it ideal for both permanent clinics and temporary health camps."
      />

      <div id="feautures" className="section-heading">
        Advancing Structured Clinical Environments
      </div>
      <div className="features-section">
        <div className="feature-card">
          <h3>Structured Patient Data Capture</h3>
          <p>
            Enables systematic and standardized recording of patient
            information.
          </p>
        </div>
        <div className="feature-card">
          <h3>Standardized Clinical Documentation</h3>
          <p>
            Maintains uniform and compliant clinical records across the board.
          </p>
        </div>
        <div className="feature-card">
          <h3>Integrated Prescription Workflows</h3>
          <p>
            Connects prescribing, dispensing, and management in a seamless flow.
          </p>
        </div>
        <div className="feature-card">
          <h3>Laboratory Data Traceability</h3>
          <p>
            Ensures complete and auditable tracking of lab samples and results.
          </p>
        </div>
        <div className="feature-card">
          <h3>Controlled Administrative Oversight</h3>
          <p>
            Provides administrators with tools to manage and monitor operations
            effectively.
          </p>
        </div>
        <div className="feature-card">
          <h3>Role-Based Access Control (RBAC)</h3>
          <p>
            Ensures that users can only access information and functions
            appropriate for their role.
          </p>
        </div>
      </div>

      <div id="management" className="section-heading">
        Versatile Management Capabilities
      </div>
      <div className="features-section">
        <div className="feature-card">
          <h3>Clinic Management</h3>
          <p>
            Streamline day-to-day clinic operations, from patient registration
            and appointment scheduling to billing and inventory management.
            AiClinics provides a centralized system for all your clinic's
            administrative and clinical needs.
          </p>
        </div>
        <div className="feature-card">
          <h3>Camp Management</h3>
          <p>
            Efficiently manage health camps of any scale. The platform supports
            rapid patient onboarding, mobile data entry, and offline
            capabilities, ensuring smooth operations even in remote locations
            with limited connectivity.
          </p>
        </div>
      </div>

      <div id="architecture" className="section-heading">
        Core Platform Architecture
      </div>
      <div className="features-vertical">
        <div className="feature-section dark">
          <div className="feature-content">
            <h2>Clinical Documentation & Case Management</h2>
            <p>
              Structured patient registration and longitudinal records,
              standardized consultation templates, digitally generated
              prescriptions, and audit-ready documentation trails.
            </p>
          </div>
        </div>

        <div className="feature-section light">
          <div className="feature-content">
            <h2>Integrated Pharmacy Operations</h2>
            <p>
              Prescription-linked dispensing, inventory lifecycle management,
              batch, lot, and expiry monitoring, and controlled medication logs.
            </p>
          </div>
        </div>

        <div className="feature-section dark">
          <div className="feature-content">
            <h2>Laboratory Coordination</h2>
            <p>
              Diagnostic order management, sample lifecycle tracking, result
              validation workflows, and laboratory report integration.
            </p>
          </div>
        </div>
      </div>

      <div id="whyUs" className="section-heading">
        Built for Precision. Designed for Accountability.
      </div>
      <div className="features-vertical">
        <div className="feature-section dark">
          <div className="feature-content">
            <h2>Reduces Data Fragmentation</h2>
            <p>
              Consolidates clinic, pharmacy, and laboratory systems into a
              single governed platform.
            </p>
          </div>
          <div className="feature-image">
            <img src={accuracy} alt="Reduces Data Fragmentation" />
          </div>
        </div>

        <div className="feature-section light">
          <div className="feature-image">
            <img src={savetime} alt="Improves Documentation Reliability" />
          </div>
          <div className="feature-content">
            <h2>Improves Documentation Reliability</h2>
            <p>
              Enhances the quality and consistency of clinical and operational
              records.
            </p>
          </div>
        </div>

        <div className="feature-section dark">
          <div className="feature-content">
            <h2>Enhances Interdepartmental Coordination</h2>
            <p>
              Streamlines communication and workflows between different
              departments.
            </p>
          </div>
          <div className="feature-image">
            <img
              src={userFriendly}
              alt="Enhances Interdepartmental Coordination"
            />
          </div>
        </div>

        <div className="feature-section light">
          <div className="feature-image">
            <img src={dataSecurity} alt="Strengthens Compliance Readiness" />
          </div>
          <div className="feature-content">
            <h2>Strengthens Compliance Readiness</h2>
            <p>
              Supports adherence to regulatory and research standards with
              robust documentation and controls.
            </p>
          </div>
        </div>

        <div className="feature-section dark">
          <div className="feature-content">
            <h2>Cross-Platform Clinical Accessibility</h2>
            <p>
              Available on Android, iOS, and Desktop systems, ensuring
              uninterrupted operations.
            </p>
          </div>
          <div className="feature-image">
            <img src={multiPlatoform} alt="Multi-Platform Availability" />
          </div>
        </div>
      </div>

      <div id="download" className="section-heading">
        Cross-Platform Clinical Accessibility
      </div>
      <div className="download-app-logos">
        <a
          href={product.androidLink}
          download
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="logo-container">
            <img src={androidApkLogo} alt="Android" />
          </div>
        </a>

        {product.playstoreLink ? (
          <a
            href={product.playstoreLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="logo-container">
              <img src={playStoreLogo} alt="Playstore" />
            </div>
          </a>
        ) : (
          <div
            className="logo-container"
            onClick={() => UnavailableAlert("Play Store")}
          >
            <img src={playStoreLogo} alt="Playstore" />
          </div>
        )}

        {product.iosLink ? (
          <a href={product.iosLink} target="_blank" rel="noopener noreferrer">
            <div className="logo-container">
              <img src={appStoreLogo} alt="iOS" />
            </div>
          </a>
        ) : (
          <div
            className="logo-container"
            onClick={() => UnavailableAlert("App Store")}
          >
            <img src={appStoreLogo} alt="App Store" />
          </div>
        )}

        <a href={product.webLink} target="_blank" rel="noopener noreferrer">
          <div className="logo-container">
            <img src={webLogo} alt="Web" />
          </div>
        </a>
      </div>

      <div className="product-cta-section">
        <h2>Empowering Modern Clinical Research Infrastructure</h2>
        <p>
          AiClinics is more than a management tool — it is a digitally
          structured ecosystem that supports transparency, traceability, and
          operational excellence in integrated medical and research settings.
        </p>
        <div className="product-cta-buttons">
          <a href="#get-in-touch" className="product-cta-button primary">
            Contact Us
          </a>
        </div>
      </div>

      <PrivacyPolicy objectKey="Company Products/AiClinics/privacy_policy.json" />

      <Footer />
    </div>
  );
}

export default AiclinicsMainPage;
